<a href="#" title="{{filename}}" (click)="download($event)">
  <img *ngIf="content" width='24' height='24' alt="{{ content.mimeType }}" src="{{ content.mimeType | adfMimeTypeIcon }}"/>
  <span>{{ filename }}</span>
</a>
